import React from 'react';
import './App.css';
import { useEffect } from 'react';
import AmsButton from './atoms/AmsButton/AmsButton';
import JourneyContext from './journeys/context/JourneyContext';
import RootContext from './providers/RootProvider';
import ErrorBoundary from './ErrorBoundary';
import Journey from './journeys/journey/Journey';
import * as onlineBooking from "./journeys/journey/onlineBooking.json"
import "../src/atoms/AmsCalendar/style.css"
import Amplify from 'aws-amplify';
import awsconfig from './aws-exports';
import ApolloClient from 'apollo-boost';
import { ApolloProvider } from '@apollo/react-hooks';
import { AMSTheme } from './theme';
import { getSubpath,getCustomerDetails, getStepName,getJourneyName } from "./utils/helpers"
import { FullStoryAPI } from 'react-fullstory';

Amplify.configure(awsconfig)

declare const window: Window &
  typeof globalThis & {
    analytics: any,
    affirm: any
}



let graphqlEndpoint = "https://amsfanclubapi.allmysonsbeanstalk.com/graphql"

let depositurl = "https://pricingapi.allmysons.com/Estimator/SavePaymentCreditCard"


export const endpoints = {
  graphql: graphqlEndpoint,
  payment: depositurl
}

const defaultOptions: any = {
  watchQuery: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'ignore',
  },
  query: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
  },
}

export const client = new ApolloClient({
  uri: endpoints.graphql
});
function App() {

  return (
    <AMSTheme>
    {/* <ApolloProvider client={client}> */}
      <JourneyContext>

          <RootContext>
            <ErrorBoundary>
              <Journey path="" goal={onlineBooking.goal} pages={onlineBooking.pages} />
            </ErrorBoundary>
          </RootContext>
      </JourneyContext>
    {/* </ApolloProvider> */}
    </AMSTheme>
  );
}

export default App;
